import styled from "styled-components";

export const Heading = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  text-transform: capitalize;
  text-align: center;
`